import axios from "axios";
import {authHeader} from "../helpers/auth-header";

const getScheduleById = (deviceGroupId) => {
    return axios.get(`/api/schedule/${deviceGroupId}`, {headers: authHeader()})
        .then(
            res => {
                return res.data;
            }
        )
};

const editScheduleDay = (scheduleDayModel) => {
    return axios.patch(`/api/schedule/UpdateSchedule/${scheduleDayModel.id}`, scheduleDayModel, {headers: authHeader()})
        .then(
            res => {
                return res.data
            }
        );
};

const createScheduleException = (scheduleExceptionModel) => {
    return axios.post(`/api/schedule/${scheduleExceptionModel.deviceGroupId}`, scheduleExceptionModel, { headers: authHeader() })
        .then(
            res => {
                return res.data
            }
        )
};

const editScheduleException = (scheduleExceptionModel) => {
    return axios.patch(`/api/schedule/UpdateScheduleException/${scheduleExceptionModel.id}`, scheduleExceptionModel, {headers: authHeader()})
        .then(
            res => {
                return res.data
            }
        )
};

const deleteScheduleException = (scheduleExceptionId) => {
    return axios.delete(`/api/schedule/${scheduleExceptionId}`, {headers: authHeader()})
        .then(
            res => {
                return res.data
            }
        )
};

export const deviceGroupScheduleService = {
    getScheduleById,
    editScheduleDay,
    createScheduleException,
    editScheduleException,
    deleteScheduleException
};
